import { Box, Rating as StarRating } from '@mui/material';
import React, { ReactElement } from 'react';
import './OrderKpiRatingBadge.scss';

interface OrderKpiRatingBadgeProps {
  label: string;
  icon: ReactElement;
  color: string;
  value: number | string;
  onClickLabel?: () => void;
  cursorPoint?: boolean;
}

const OrderKpiRatingBadge = ({ label, icon, color, value, onClickLabel, cursorPoint }: OrderKpiRatingBadgeProps) => {
  let ratingValue = 0;

  // Handle the cases for "Rated 1" or "Rated 2"
  if (label === 'Rated 1' || label === 'Rated 2') {
    ratingValue = label === 'Rated 2' ? 2 : 1;
  } else if (label === 'Rated 0') {
    ratingValue = 0;
  }

  // Handle other cases
  // if (ratingValue === 0) {
  //   if (typeof value === 'string') {
  //     ratingValue = { A: 5, B: 4, C: 3, D: 2, E: 1 }[value] ?? 0;
  //   } else {
  //     ratingValue = Number(value);
  //   }
  // }

  return (
    <Box sx={{ mb: 1, cursor: cursorPoint ? 'pointer' : 'default' }}>
      <div className={`badge-kpi ${color}`} role="none" onClick={onClickLabel} onKeyDown={onClickLabel}>
        <div className="badge-kpi-title" style={{ display: 'block' }}>
          <span style={{ marginRight: '8px' }}>{icon}</span> {label}
          {(label === 'Rated 1' || label === 'Rated 2' || label === 'Rated 0') && (
            <div style={{ display: 'block', marginTop: '5px' }}>
              <StarRating value={ratingValue} readOnly size="small" />
            </div>
          )}
        </div>
        <span className="badge-kpi-value">{value}</span>
      </div>
    </Box>
  );
};

export default OrderKpiRatingBadge;
